import {Component, Input, OnInit, Output, EventEmitter, AfterViewInit, ElementRef, ViewChild, AfterContentInit} from '@angular/core';
import {ImageService} from '../../../services/image.service';
import {environment} from '../../../environments/environment';
import {DomSanitizer} from '@angular/platform-browser';
import {DialogService} from '../../../services/dialog.service';

declare var gtag;
declare var ga;

@Component({
  selector: 'app-video-page',
  templateUrl: './video-page.component.html',
  styleUrls: ['./video-page.component.scss'],
})
export class VideoPageComponent implements OnInit, AfterViewInit, AfterContentInit{
  // tslint:disable-next-line:no-input-rename
  @Input('imageDetail') imageDetail;
  // tslint:disable-next-line:no-output-rename
  @Output('toggleScan') takeBack = new EventEmitter();
  @ViewChild('iframe') iframe: ElementRef | undefined;
  mode = true;
  imageId: any = '';
  asset: any = [];
  hasFlash = true;
  isIframe = false;
  defaultSize = {minReqWidth: 1300, minReqHeight: 800, lsAdjustment: 6};
  sizeOverride = {
    'us-school.pk12ls.com': this.defaultSize,
    'curriculum.media.pk12ls.com': this.defaultSize,
    'schoolcontent.pk12ls.com': this.defaultSize,
    'export.mediaconsole.pearsoncmg.com': this.defaultSize,
    'media.pearsoncmg.com': this.defaultSize,
    'media.pk12ls.com': {minReqWidth: 1500, minReqHeight: 800, lsAdjustment: 20},
    'psn.virtualnerd.com': {minReqWidth: 1500, minReqHeight: 800, lsAdjustment: 6},
    'cdn.virtualnerd.com': {minReqWidth: 1500, minReqHeight: 800, lsAdjustment: 6},
    'www.virtualnerd.com': {minReqWidth: 1500, minReqHeight: 800, lsAdjustment: 6},
    'us-school.pearsoned.com': this.defaultSize
  };

  constructor(private imageService: ImageService,
              private elementRef: ElementRef,
              private domSanitizer: DomSanitizer,
              private dialogService: DialogService){
  }

  ngOnInit(): void{
    if (this.imageDetail.assets) {
      this.asset = JSON.parse(this.imageDetail.assets);
      this.hasFlash = this.imageService.appHasFlash;
    }
  }

  /*
  * Send Data to Google Analytics
  * */
  loadURL(url): any{
    if (typeof gtag !== 'undefined') {
      gtag('config', environment.google_analytics_id, {
        custom_map: {dimension2: 'action'}
      });
      gtag('event', 'action_dimension', {action: 'View Content Page'});

      gtag('config', environment.google_analytics_id, {
        custom_map: {dimension1: 'category'}
      });
      gtag('event', 'category_dimension', {category: `${this.imageDetail.program}-${this.imageDetail.booktitle}`});

      gtag('config', environment.google_analytics_id, {
        custom_map: {dimension3: 'label'}
      });
      gtag('event', 'label_dimension', {label: url});
    }

    const safeURL = url.replace(new RegExp('\\bhttp\\b'), 'https');
    return this.domSanitizer.bypassSecurityTrustResourceUrl(safeURL);
  }

  toggleScan(btn): void{
    setTimeout(() => {
      this.takeBack.emit(btn);
    }, 1000);
  }

  ngAfterViewInit(): void{
    window.addEventListener('offline', () => {
      this.dialogService.hideDialog();
      this.dialogService.showDialog('NETWORK');
    });
    // document.documentElement.requestFullscreen().catch((fullscreenErr) => console.log(fullscreenErr));
  }

  /*
  * Reduce the zoom level to make the content fit inside the iframe
  * */
  changeIframeHeight(): void{
    const iframe = this.iframe?.nativeElement;
    if (iframe) {
      const assetDomain = (iframe.src || '').substring(8, (iframe.src || '').indexOf('/', 8));
      const isSCO = (iframe.src || '').toLowerCase().endsWith('player.html');

      const sizes = this.sizeOverride[assetDomain] || this.defaultSize;
      const availableWidth = iframe.clientWidth;
      const availableHeight = iframe.clientHeight;
      const isPortrait = screen.availHeight > screen.availWidth;
      // zoom out a bit more when landscape due to smaller space available
      // tslint:disable-next-line:max-line-length
      const ratioW = (availableWidth / (sizes.minReqWidth * (1 + (isPortrait ? 0 : (screen.availWidth / screen.availHeight / sizes.lsAdjustment)))));
      const ratioH = (availableHeight / (sizes.minReqHeight * (1 + (isPortrait ? 0 : (1 / sizes.lsAdjustment)))));

      // var ratio = availableWidth / minReqWidth;
      const extendTo = (100 / Math.min(ratioW, ratioH)) + '%';
      const scale = 'scale(' + Math.min(ratioW, ratioH) + ')';
      iframe.style.webkitTransform = scale;
      iframe.style.MozTransform = scale;
      iframe.style.msTransform = scale;
      iframe.style.OTransform = scale;
      iframe.style.transform = scale;

      // keep the iframe element to the top right
      const tOrigin = '0 0';
      iframe.style.webkitTransformOrigin = tOrigin;
      iframe.style.MozTransformOrigin = tOrigin;
      iframe.style.msTransformOrigin = tOrigin;
      iframe.style.OTransformOrigin = tOrigin;
      iframe.style.transformOrigin = tOrigin;

      // extend width and height
      iframe.style.width = extendTo;
      iframe.style.height = extendTo;
    }

  }

  ngAfterContentInit(): void{
    this.asset.forEach((prop, index) => {
      if (prop.extension !== 'pdf') {
        this.asset[index].url = this.loadURL(prop.url);
      }
      if (prop.extension === 'html' || prop.extension === 'link') {
        setTimeout(() => {
          const iframe = this.iframe?.nativeElement;
          const url = (iframe.src || '');
          const isSCO = url.toLowerCase().endsWith('player.html');
          if (isSCO) {
            try {
              fetch(url.substring(0, url.length - 11) + 'auth/metadata.json')
                .then(response => response.text())
                .then(data => {
                  /*
                    audiorootsco: 							audio
                    inv3rootsco, canarootsco, ngssrootsco: 	large video, interactive activity
                    envrootsco: 								true, large videos - autoplay error
                    rootsco: 									large video
                    ngsrootsco, envflk5rootsco, env68rootsco, envagarootsco, phxelarootsco: true, large video
                   */
                  // skip rescaling for audio SCOs
                  if (!data || data.toString().indexOf('"audiorootsco"') < 0) {
                    this.changeIframeHeight();
                  }
                });
            } catch (e) {
              this.changeIframeHeight();
            }
          } else {
            this.changeIframeHeight();
          }
        }, 3000);
      }
    });
  }

}

